import React from 'react';

import { Message } from 'primereact/message';
import { useSelector } from 'react-redux';

import { RootState } from '../../state/store';
import { transformVisibilityArrayToMap } from '../rolesHelpters';

type VisibilityWrapperProps = {
  code: string; // Visibility code
  children: React.ReactNode; // Content to render if visible
};

const VisibilityWrapper: React.FC<VisibilityWrapperProps> = ({
  code,
  children
}) => {
  const elementUIs = useSelector((state: RootState) => state.auth.elementUIs);
  const visibilityClasses = transformVisibilityArrayToMap(elementUIs);
  const isTestMode = localStorage.getItem('isTestMode') === 'true';
  if (
    !visibilityClasses[code] &&
    !isTestMode &&
    !visibilityClasses['wholeui__roles']
  ) {
    return (
      <div className="card">
        <Message className="w-full" severity="warn" text="Доступ запрещен" />
        <div style={{ display: 'none' }}>{children}</div>
      </div>
    );
  }

  return <>{children}</>;
};

export default VisibilityWrapper;
